import { emitConsentChangedEvent } from "./emitConsentChangedEvent";
import { setupConsentChangedListener } from "./setupConsentChangedListener";
import { observePreferenceCenterMutations } from "./observePreferenceCenterMutations";
import { logOneTrustData } from "./logOneTrustData";
import { trackAnalytics } from "./trackAnalytics";

const moveOneTrustBannerToA11yFriendlyLocation = () => {
  const banner = document.getElementById("onetrust-consent-sdk");
  document.body.prepend(banner);
};

export const handleSdkLoad = store => () => {
  window.OptanonWrapper = undefined;

  moveOneTrustBannerToA11yFriendlyLocation();
  observePreferenceCenterMutations(store);
  setupConsentChangedListener(emitConsentChangedEvent);
  emitConsentChangedEvent();
  logOneTrustData();
  trackAnalytics();
};
